module.exports = __webpack_public_path__ + "img/img2.f35baa07.jpg";